import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IWebsiteStats } from "../models/WebsiteStats";

interface DefaultResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export default function useWebsiteStats(websiteId: string, from: Date, to: Date) {
  const { get } = useApiHelper();

  const fromStr = from.toISOString().split("T")[0];
  const toStr = to.toISOString().split("T")[0];

  const statsQuery = useQuery<DefaultResponse<IWebsiteStats>>({
    queryKey: ["websiteStats", websiteId, fromStr, toStr],
    queryFn: () =>
      get<DefaultResponse<IWebsiteStats>>(
        `/stats/website/${websiteId}?from=${fromStr}&to=${toStr}`
      ),
    enabled: !!websiteId,
    staleTime: 1000 * 60,
  });

  return {
    statsQuery,
    stats: statsQuery.data?.data,
  };
}
